<template>
     <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
        <h1>Member Report</h1>
        <div class="container-form">
          <div class="section">
            <div class="wrapper mg-top1">
                <div class="input-data">
                  <p>Province ID</p>
                  <select class="select-css mg-top1" name="" id="" v-model="prov_id" @change="getListKabupaten()">
                    <option value="" disabled selected>Select Province :</option>
                    <option v-for="(data, index) in listProvince" :key="index" :value="data.prov_id">{{ data.prov_name }}</option>
                  </select>
                </div>
                <br>
                <div class="input-data mg-top">
                  <p>Kabupaten/Kota ID</p>
                  <select class="select-css mg-top1" v-model="kab_id" @change="getListKecamatan()">
                    <option value="" disabled selected>Select Kabupaten :</option>
                    <option v-for="(data, index) in listKabupaten" :key="index" :value="data.kab_id">{{ data.kab_name }}</option>
                  </select>
                </div>
                <br>
                <div class="input-data mg-top">
                  <p>Kecamatan ID</p>
                  <select class="select-css mg-top1" v-model="kec_id" @change="getListKelurahan()">
                    <option value="" disabled selected>Select Kecamatan :</option>
                    <option v-for="(data, index) in listKecamatan" :key="index" :value="data.kec_id">{{ data.kec_name }}</option>
                  </select>
                </div>
                <br>
                <div class="input-data mg-top">
                  <p>Kelurahan/Desa ID</p>
                  <select class="select-css mg-top1" v-model="kel_id">
                    <option value="" disabled selected>Select Kelurahan :</option>
                    <option v-for="(data, index) in listKelurahan" :key="index" :value="data.kel_id">{{ data.kel_name }}</option>
                  </select>
                </div>
                <br>
                <div class="mg-top">
                  <!-- <div class="grid-input">
                    <div class="date--picker">
                        <p class="mg-btm-5">Start Date</p>
                        <datepicker placeholder="Select Date" 
                            v-model="start_date" 
                            >
                        </datepicker>
                    </div>
                    <div class="date--picker">
                        <p class="mg-btm-5">End Date</p>
                        <datepicker placeholder="Select Date" 
                            v-model="end_date" 
                            >
                        </datepicker>
                    </div>
                  </div> -->
                  <div>
                    <p style="font-weight: bold">Select Date</p>
                    <date-picker class="mg-top1" v-model="eventDate" value-type="date" range type="date"></date-picker>
                  </div>
                </div>
            </div>
            <div class="btn-heading">
              <!-- <p class="mg-top" v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                      <li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
                  </ul>
              </p> -->

              <button class="btn-add mg-top1" @click="getData()">
                  Download
              </button>
            </div>
          </div>
        </div>
    </div>
  </div>
    
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
// import Datepicker from 'vuejs-datepicker';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import axios from 'axios';

import 'vue2-datepicker/index.css';

import auth from '@/service/auth.js'

export default {
  name: 'Home',
  data() {
    return {
        isLoading: false,
        isPlaying: false,
        error: [],

        listProvince: [],
        prov_id: '',

        listKabupaten: [],
        kab_id: '',

        listKecamatan: [],
        kec_id: '',

        listKelurahan: [],
        
        kel_id: '',
        start_date: '',
        end_date: '',
        eventDate: []


    }
  },
  methods: {
    async getListProvince() {
      this.isLoading = true
      try {
          const response = await axios.get('/member/listprovinsi')
          console.log(response)

          this.listProvince = response.data
          this.isLoading = false
      } catch (error) {
          console.log(error)
      }
    },
    async getListKabupaten() {
      this.kab_id = ''
      this.kec_id = ''
      this.kel_id = ''
      this.isLoading = true
      try {
          const response = await axios.get('/member/listkabupatenkota', {
            params: {
              prov_id: this.prov_id
            }
          })
          console.log(response)

          this.listKabupaten = response.data
          this.isLoading = false
      } catch (error) {
          console.log(error)
      }
    },
    async getListKecamatan() {
      this.kec_id = ''
      this.isLoading = true
      try {
          const response = await axios.get('/member/listkecamatan', {
            params: {
              kab_id: this.kab_id
            }
          })
          console.log(response)

          this.listKecamatan = response.data
          this.isLoading = false
      } catch (error) {
          console.log(error)
      }
    },
    async getListKelurahan() {
      this.isLoading = true
      try {
          const response = await axios.get('/member/listkelurahandesa', {
            params: {
              kec_id: this.kec_id
            }
          })
          console.log(response)

          this.listKelurahan = response.data
          console.log('dataKabupaten', this.listKelurahan)
          this.isLoading = false
      } catch (error) {
          console.log(error)
      }
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    },
    async getData () {
      const res = await auth.checkAuth(this.$route.fullPath)
      if (res == false) {
          localStorage.clear()
          alert.failed('Unauthorized Token', () => this.$router.push('/login'))
      } else {
        this.isLoading = true
        try {
          // let startDate = this.start_date ? moment(this.start_date).format() : ''
          // let endDate = this.end_date ? moment(this.end_date).format() : ''

          let startDate = this.start_date ? moment(this.eventDate[0]).format() : ''
          let endDate = this.end_date ? moment(this.eventDate[1]).format() : ''

          const response = await axios.get('/member/memberreport', {
            params: {
              prov_id: this.prov_id,
              kab_id: this.kab_id,
              kec_id: this.kec_id,
              kel_id: this.kel_id,
              start_date: startDate,
              end_date: endDate,
            },
            responseType: 'blob'
          })
          this.isLoading = false
  
          let current = new Date()
          const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
          console.log('date', date)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `report_${date}.xlsx`)
          document.body.appendChild(link)
  
          link.click()
          alert.success('Data Downloaded')
  
          this.prov_id = ''
          this.kab_id = ''
          this.kec_id = ''
          this.kel_id = ''
  
        } catch (error) {
          console.log(error)
          alert.failed('Data Not Found')
          this.isLoading = false
        }
      }
    },
  },
  components: {
    // Datepicker,
    DatePicker,
    Loader
  },
  async created () {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
    this.getListProvince()
  }
}
</script>